/**
 * Detecta si el dispositivo es móvil
 * @returns {boolean} true si es móvil, false si es desktop
 */
export const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};

/**
 * Obtiene el tipo de dispositivo
 * @returns {string} 'mobile' o 'desktop'
 */
export const getDeviceType = () => {
  return isMobileDevice() ? 'mobile' : 'desktop';
};

/**
 * Obtiene el path apropiado para WhatsApp según el dispositivo
 * @returns {string} 'api' para móvil, 'web' para desktop
 */
export const getWhatsAppPath = () => {
  return isMobileDevice() ? 'api' : 'web';
};
